import { Request, Response } from "@siteimprove/alfa-http";
import { Refinement } from "@siteimprove/alfa-refinement";
const { isObject } = Refinement;
/**
 * @public
 */
export var Resource;
(function (Resource) {
    function isResource(value) {
        return (isObject(value) &&
            Request.isRequest(value.request) &&
            Response.isResponse(value.response));
    }
    Resource.isResource = isResource;
})(Resource || (Resource = {}));
//# sourceMappingURL=resource.js.map